import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import Icon from '../Icons'

class TransactionFinishedPopup extends Component {
  constructor(props) {
    super(props)
    this.closeAction = this.closeAction.bind(this)
  }

  closeAction(e) {
    e.preventDefault()
    if (this.props.transactionStatus !== 'pending') {
      this.props.closeCallback()
    }
  }

  render() {
    const { isOpen, title, closeText, className, transactionStatus, cost, transactionId, t } =
      this.props
    const isLoading = transactionStatus === 'pending'
    return (
      <div
        className={`modal modal--confirm modal--finished-transaction ${
          isOpen ? 'is-active' : ''
        } ${className || ''}`}
      >
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            <header className="modal__header">
              <span>{title}</span>
              <button
                className="modal-close is-large"
                aria-label={t('store:transactionPopup.closeAria')}
                onClick={this.closeAction}
              />
            </header>
            <div className="modal__inner">
              <div className="modal__body">
                <div className={`modal__transaction modal__transaction--${transactionStatus}`}>
                  <div className="modal__transaction-emblem">
                    {transactionStatus === 'success' && (
                      <Icon icon={'checkmark'} viewBox={'30 30 0 0'} />
                    )}
                    {transactionStatus === 'failed' && <Icon icon={'cross'} />}
                  </div>
                  <div className="modal__transaction-payment">
                    {transactionStatus === 'success' && (
                      <span>
                        {t('store:transactionPopup.success', { amount: (cost / 100).toFixed(2) })}
                      </span>
                    )}
                    {transactionStatus === 'failed' && (
                      <span>{t('store:transactionPopup.failed')}</span>
                    )}
                  </div>
                  <div className="modal__transaction-contact">
                    {transactionStatus === 'success' && (
                      <span>{t('store:transactionPopup.confirmationEmail')}</span>
                    )}
                    {transactionStatus === 'failed' && (
                      <span>{t('store:transactionPopup.contactSupport')}</span>
                    )}
                  </div>
                  {transactionStatus !== 'failed' && cost !== 0 && (
                    <div className="modal__transaction-id">
                      {transactionStatus === 'success' && (
                        <span>
                          {t('store:transactionPopup.transactionIdPrefix')}
                          <strong>{transactionId}</strong>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="modal__section modal__actions">
                <button
                  className={`button button-gray ${isLoading ? 'is-loading' : ''}`}
                  onClick={this.closeAction}
                >
                  {closeText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

TransactionFinishedPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  closeText: PropTypes.string,
  closeCallback: PropTypes.func,
  className: PropTypes.string,
  transactionStatus: PropTypes.string,
  cost: PropTypes.number,
  transactionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t: PropTypes.func,
}

TransactionFinishedPopup.defaultProps = {
  className: '',
}

export default withTranslation(['store'])(TransactionFinishedPopup)
